import React from "react";
import TooltipV2 from "@/components/UI/Tooltip";

import { useMetricCardConfig } from "./ConfigForm_Context";
import { ConfigForm_SectionWrapper } from "./ConfigForm_SectionWrapper";
import { TitleInputWithDefault } from "../../utils/TitleInputWithDefault";
import { DATA_KEYS } from "./DATA_KEYS";

/**
 * Caption only. There is no measure-mode ("Type") selector: the mode follows
 * from WHAT is picked in the Data section — a dataset folder means document
 * count, a field inside it means field statistic. See ConfigForm_DataSection.
 */
export const ConfigForm_CaptionSection = () => {
  const { widgetConfig, setConfig, underEditWidgetIdx } = useMetricCardConfig();

  return (
    <ConfigForm_SectionWrapper icon="Selection" title="Selected Card">
      <TooltipV2 text="Add a custom caption for this metric card" placement="right">
        <TitleInputWithDefault
          widgetConfig={widgetConfig}
          widgetType="WidgetMetricCard"
          setConfig={setConfig}
          underEditWidgetIdx={underEditWidgetIdx}
          titlePath={DATA_KEYS.field1}
          tagLabel="CAPTION"
          placeholder="Update custom label"
        />
      </TooltipV2>
    </ConfigForm_SectionWrapper>
  );
};
